import { Modal } from 'carbon-components-react';
import React, { useState, useEffect } from 'react';
import Step1 from '../../Molecules/Steps/Step1';
import Step2 from '../../Molecules/Steps/Step2';
import Step3 from '../../Molecules/Steps/Step3';
import Step4 from '../../Molecules/Steps/Step4';
import Step5 from '../../Molecules/Steps/Step5';
import Step6 from '../../Molecules/Steps/Step6';
import Step7 from '../../Molecules/Steps/Step7';
import {
  QuesIDProps,
  que5ValueProps,
  que6ValueProps,
} from '../../WatsonxOrchestrateSelfAssessment';
import { Restart16 } from '@carbon/icons-react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from 'src/apps/watsonx-orchestrate-self-assessment/locales/messages';
import { segmentsTracking } from 'src/common/lib/tracker';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import PublicImage from 'src/common/components/PublicImage';
import Progress from '../../Molecules/Progress/Progress';

type PopUpModalProps = {
  langCode: string;
  bpName: string;
  logo: string;
  companyId: string;
  open: boolean;
  handleCloseModal: () => void;
  handleCloseQuestions: () => void;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  que1Value: string;
  setQue1Value: React.Dispatch<React.SetStateAction<string>>;
  que2Value: string;
  setQue2Value: React.Dispatch<React.SetStateAction<string>>;
  que3Value: string;
  setQue3Value: React.Dispatch<React.SetStateAction<string>>;
  que4Value: string;
  setQue4Value: React.Dispatch<React.SetStateAction<string>>;
  que5Value: que5ValueProps;
  setQue5Value: React.Dispatch<React.SetStateAction<que5ValueProps>>;
  que6Value: que6ValueProps;
  setQue6Value: React.Dispatch<React.SetStateAction<que6ValueProps>>;
  que7Value: string;
  setQue7Value: React.Dispatch<React.SetStateAction<string>>;
  trackQuesID: QuesIDProps;
  setTrackQuesID: React.Dispatch<React.SetStateAction<QuesIDProps>>;
  formComplete: boolean;
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFormComplete: React.Dispatch<React.SetStateAction<boolean>>;
  handleUrxForm: () => void;
  localeCode: string;
  reset: () => void;
  que1Points: number;
  setQue1Points: React.Dispatch<React.SetStateAction<number>>;
  que2Points: number;
  setQue2Points: React.Dispatch<React.SetStateAction<number>>;
  que3Points: number;
  setQue3Points: React.Dispatch<React.SetStateAction<number>>;
  que4Points: number;
  setQue4Points: React.Dispatch<React.SetStateAction<number>>;
  que5Points: number;
  setQue5Points: React.Dispatch<React.SetStateAction<number>>;
  que6Points: number;
  setQue6Points: React.Dispatch<React.SetStateAction<number>>;
  que7Points: number;
  setQue7Points: React.Dispatch<React.SetStateAction<number>>;
  totalPoints: number;
  setTotalPoints: React.Dispatch<React.SetStateAction<number>>;
  pathSelected: string;
};

const Assessment = ({
  open,
  handleCloseModal,
  handleCloseQuestions,
  step,
  setStep,
  que1Value,
  setQue1Value,
  que2Value,
  setQue2Value,
  que3Value,
  setQue3Value,
  que4Value,
  setQue4Value,
  que5Value,
  setQue5Value,
  que6Value,
  setQue6Value,
  que7Value,
  setQue7Value,
  trackQuesID,
  setTrackQuesID,
  reset,
  bpName,
  logo,
  handleUrxForm,
  que1Points,
  setQue1Points,
  que2Points,
  setQue2Points,
  que3Points,
  setQue3Points,
  que4Points,
  setQue4Points,
  que5Points,
  setQue5Points,
  que6Points,
  setQue6Points,
  que7Points,
  setQue7Points,
  setTotalPoints,
  pathSelected,
}: PopUpModalProps) => {
  const [picture, setPicture] = useState('images/Business_Q1.svg');

  const handleReset = () => {
    reset();
  };

  const handleSegmentTracking = (cta: string) => {
    segmentsTracking('CTA Clicked', {
      pageTitle: 'Watsonx Orchestrate Self Assessment',
      object: 'Watsonx Orchestrate SA page',
      resultValue: 'CTA clicked',
      CTA: cta,
      location: `${pathSelected} Path Selection`,
      action: '',
      field: '',
    });
  };

  const intl = useIntl();

  useEffect(() => {
    if (step === 1 && pathSelected === 'Non-Tech') {
      setPicture('images/Business_Q1.svg');
    } else if (step === 1 && pathSelected === 'Tech') {
      setPicture('images/IT_Q1.svg');
    } else if (step === 2 && pathSelected === 'Non-Tech') {
      setPicture('images/Business_Q2.svg');
    } else if (step === 2 && pathSelected === 'Tech') {
      setPicture('images/IT_Q2.svg');
    } else if (step === 3) {
      setPicture('images/Business_IT_Q3.svg');
    } else if (step === 4) {
      setPicture('images/Business_IT_Q4.svg');
    } else if (step === 5) {
      setPicture('images/Business_IT_Q5.svg');
    } else if (step === 6 && pathSelected === 'Non-Tech') {
      setPicture('images/Business_Q6.svg');
    } else if (step === 6 && pathSelected === 'Tech') {
      setPicture('images/IT_Q6.svg');
    } else if (step === 7) {
      setPicture('images/Business_IT_Q7.svg');
    }
    setTotalPoints(
      que1Points +
        que2Points +
        que3Points +
        que4Points +
        que5Points +
        que6Points +
        que7Points,
    );
  }, [
    step,
    pathSelected,
    que1Points,
    que2Points,
    que3Points,
    que4Points,
    que5Points,
    que6Points,
    que7Points,
  ]);

  return (
    <div className="bx--grid">
      <Modal
        open={open}
        onRequestClose={handleCloseModal}
        primaryButtonText={intl.formatMessage(messages.next_btn)}
        secondaryButtonText={intl.formatMessage(messages.back_btn)}
        preventCloseOnClickOutside={true}
        onRequestSubmit={() => {
          if (step === 7) {
            handleSegmentTracking('Next on step 7');
            handleUrxForm();
          } else {
            handleSegmentTracking('Next on step ' + step);
            setStep((step) => step + 1);
          }
        }}
        size="lg"
        onSecondarySubmit={() => {
          if (step > 1) {
            setStep((step) => step - 1);
            handleSegmentTracking('Back on step ' + step);
          } else {
            handleCloseQuestions();
            handleSegmentTracking('Close');
            setStep(1);
            handleReset();
          }
        }}
      >
        <div className="modal_padding">
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
              {bpName ? (
                <BusinessPartner bpName={bpName} logo={logo} urxForm={true} />
              ) : null}
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-12 bx--col-md-16 bx--col-sm-16">
              <span className="page_sub_heading">
                <FormattedMessage {...messages.page_title} />
              </span>
            </div>
            <div className="bx--col-lg-3 bx--col-md-16 bx--col-sm-16">
              {que1Value && (
                <div className="reset-item" onClick={handleReset}>
                  <span>
                    <FormattedMessage {...messages.start_over} />
                  </span>
                  <Restart16 className="restart-icon" />
                </div>
              )}
            </div>
          </div>
          <div className="bx--row padButton">
            <div className="bx--col-lg-1 bx--col-md-16 bx--col-sm-16">
              <p className="progress_label">{step}/7</p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
              <Progress current={step - 1} />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-10 bx--col-md-16 bx--col-sm-16">
              {step === 1 && (
                <Step1
                  pathSelected={pathSelected}
                  que1Value={que1Value}
                  setQue1Value={setQue1Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que1Points={que1Points}
                  setQue1Points={setQue1Points}
                />
              )}
              {step === 2 && (
                <Step2
                  pathSelected={pathSelected}
                  que2Value={que2Value}
                  setQue2Value={setQue2Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que2Points={que2Points}
                  setQue2Points={setQue2Points}
                />
              )}
              {step === 3 && (
                <Step3
                  pathSelected={pathSelected}
                  que3Value={que3Value}
                  setQue3Value={setQue3Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que3Points={que3Points}
                  setQue3Points={setQue3Points}
                />
              )}
              {step === 4 && (
                <Step4
                  pathSelected={pathSelected}
                  que4Value={que4Value}
                  setQue4Value={setQue4Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que4Points={que4Points}
                  setQue4Points={setQue4Points}
                />
              )}
              {step === 5 && (
                <Step5
                  pathSelected={pathSelected}
                  que5Value={que5Value}
                  setQue5Value={setQue5Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que5Points={que5Points}
                  setQue5Points={setQue5Points}
                />
              )}
              {step === 6 && (
                <Step6
                  pathSelected={pathSelected}
                  que6Value={que6Value}
                  setQue6Value={setQue6Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que6Points={que6Points}
                  setQue6Points={setQue6Points}
                />
              )}
              {step === 7 && (
                <Step7
                  pathSelected={pathSelected}
                  que7Value={que7Value}
                  setQue7Value={setQue7Value}
                  setTrackQuesID={setTrackQuesID}
                  trackQuesID={trackQuesID}
                  que7Points={que7Points}
                  setQue7Points={setQue7Points}
                />
              )}
            </div>
            <div className="bx--col-lg-6 bx--col-md-16 bx--col-sm-16">
              <PublicImage
                imgPath={picture}
                widgetId="watsonx-orchestrate-self-assessment"
                id="img2"
                alt="Watsonx Orchestrate Self Assessment Steps picture"
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Assessment;
